import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBxVSXj38tZP0WuNHTqI5vDV11AEs0LOo4",
  authDomain: "payda-clone.firebaseapp.com",
  projectId: "payda-clone",
  storageBucket: "payda-clone.appspot.com",
  messagingSenderId: "981381976204",
  appId: "1:981381976204:web:c9224e1400c0fe23b1eba9",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();

export { storage, auth };
export default db;
